@if (isOrderLoading) {
  <div class="centered-loading">
    <p-progress-spinner ariaLabel="loading" />
  </div>
}
<div class="grid flex header-gap">
  <div class="grid pb-5">
    <div class="col-12">
      <div class="page-header mb-5 gap-0">
        <h1 class="orders">{{ 'Checkout.NewOrder' | translate }} #{{ orderData?.id }}</h1>
        <div class="yellow-underline"></div>
      </div>
    </div>
    <div class="col-12 pr-3">
      <div class="md:flex md:justify-content-between">
        <h4>{{ getOrderItemAttribute('name') }}</h4>
      </div>
    </div>
    @if (isActive(orderData)) {
      <div class="col-12">
        <app-checkout-stepper />
      </div>
    } @else {
      @if (!isOrderLoading) {
        <div class="p-2">
          <p-message severity="info" [closable]="false" icon="pi pi-info-circle">
            <div class="content-box">
              <span class="summary-txt">Info</span>
              <span>{{ 'Order.InactiveOrderItem' | translate }}</span>
            </div>
          </p-message>
        </div>
      }
    }
  </div>
</div>

<p-confirmDialog />
